var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.35156 7H17.3516M1.35156 7V15.8002C1.35156 16.9203 1.35156 17.4801 1.56955 17.9079C1.7613 18.2842 2.06704 18.5905 2.44336 18.7822C2.87076 19 3.43056 19 4.54847 19H14.1547C15.2726 19 15.8316 19 16.259 18.7822C16.6353 18.5905 16.942 18.2842 17.1338 17.9079C17.3516 17.4805 17.3516 16.9215 17.3516 15.8036V7M1.35156 7V6.2002C1.35156 5.08009 1.35156 4.51962 1.56955 4.0918C1.7613 3.71547 2.06704 3.40973 2.44336 3.21799C2.87118 3 3.43165 3 4.55176 3H5.35156M17.3516 7V6.19691C17.3516 5.07899 17.3516 4.5192 17.1338 4.0918C16.942 3.71547 16.6353 3.40973 16.259 3.21799C15.8311 3 15.2719 3 14.1518 3H13.3516M5.35156 3H13.3516M5.35156 3V1M13.3516 3V1M12.3516 11L8.35156 15L6.35156 13",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d1aef52ab2d826c5132a118c397718ea.svg";
export { ForwardRef as ReactComponent };